module.exports = __webpack_public_path__ + "img/Shield.90996ff3.svg";